import broadcastIcon from 'app/assets/icons/sidebar/broadcast.svg';
import calendarIcon from 'app/assets/icons/sidebar/calendar.svg';
import patientsIcon from 'app/assets/icons/sidebar/patients.svg';
import productLibraryIcon from 'app/assets/icons/sidebar/product-library.svg';
import servicesIcon from 'app/assets/icons/sidebar/services.svg';
import smsCampaignsIcon from 'app/assets/icons/sidebar/sms-campaigns.svg';
import superLinksIcon from 'app/assets/icons/sidebar/super-links.svg';
import userManagementIcon from 'app/assets/icons/sidebar/user-management.svg';
import websiteBuilderIcon from 'app/assets/icons/sidebar/website-builder.svg';
import type { SidebarNavItem } from 'app/fuse-layouts/shared-components/SidebarNavigation/types';

// Pages both regions have, with the label, icon and route they share. Each region's config adds
// its own roles and tags (`auth`, `plusFeature`) and any naming it keeps on purpose. The labels are
// plain titles, not `translate` keys, so a rename happens in one place.
export const patientsItem = {
  id: 'patients-component',
  title: 'Patients',
  type: 'item',
  img: patientsIcon,
  url: 'patients',
} satisfies SidebarNavItem;

export const calendarItem = {
  id: 'calendar',
  title: 'Calendar',
  type: 'item',
  img: calendarIcon,
  url: 'calendar',
} satisfies SidebarNavItem;

export const servicesItem = {
  id: 'services',
  title: 'Services',
  type: 'item',
  img: servicesIcon,
  url: 'services',
} satisfies SidebarNavItem;

export const websiteBuilderItem = {
  id: 'plus-websites',
  title: 'Website builder',
  type: 'item',
  img: websiteBuilderIcon,
  url: 'plus-websites',
} satisfies SidebarNavItem;

export const broadcastsItem = {
  id: 'broadcasts',
  title: 'Broadcast',
  type: 'item',
  img: broadcastIcon,
  url: 'campaigns/broadcasts',
} satisfies SidebarNavItem;

export const superLinksItem = {
  id: 'super-links',
  title: 'Super links',
  type: 'item',
  img: superLinksIcon,
  url: 'super-links',
} satisfies SidebarNavItem;

export const smsCampaignsItem = {
  id: 'sms-campaigns',
  title: 'SMS campaigns',
  type: 'item',
  img: smsCampaignsIcon,
  url: 'sms-campaigns',
} satisfies SidebarNavItem;

export const userManagementItem = {
  id: 'organisation-users',
  title: 'User management',
  type: 'item',
  img: userManagementIcon,
  url: 'users',
} satisfies SidebarNavItem;

export const masterServicesItem = {
  id: 'master-services',
  title: 'Master services',
  type: 'item',
  img: productLibraryIcon,
  url: 'master-services',
} satisfies SidebarNavItem;

export const lunarReviewsItem = {
  id: 'lunar-reviews',
  title: 'Lunar Reviews',
  type: 'item',
  img: productLibraryIcon,
  url: 'lunar-reviews',
} satisfies SidebarNavItem;
